/*
 * Copyright (c) 2023 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { DivIconOptions, Icon, Marker, MarkerCluster, MarkerOptions } from 'leaflet';
import L from 'leaflet';
import { customIcon } from './consts';
import { CashBoxPoint, Claster } from '../../data/api/cashBoxes/cashBoxesClient.typings';
import Geohash from 'latlon-geohash';

export interface CustomMarker extends Marker {
    options: CustomMarkerOptions;
}

export const iconCreateFunction = (cluster: MarkerCluster) => {
    const markers = cluster.getAllChildMarkers();
    let markerCount = 0;

    markers.forEach((m: CustomMarker) => {
        if ('count' in m.options) {
            markerCount = markerCount + m.options.count;
        } else {
            markerCount = markerCount + 1;
        }
    });

    return createClusterIcon(markerCount);
};

export const createClusterIcon = (itemsCount: number): Icon<DivIconOptions> => {
    let styleClasterClass = ' marker-cluster-';

    if (itemsCount < 10) {
        styleClasterClass += 'small';
    } else if (itemsCount < 100) {
        styleClasterClass += 'medium';
    } else {
        styleClasterClass += 'large';
    }

    return new L.DivIcon({
        html: '<div><span>' + itemsCount + '</span></div>',
        className: 'marker-cluster' + styleClasterClass,
        iconSize: new L.Point(40, 40),
    });
};

export interface ClasterPoint {
    lat: number;
    lon: number;
    count: number;
}

export interface CustomMarkerOptions extends MarkerOptions {
    count?: number;
    taxNumber?: string;
}

export const createMarkerOptions = (point: ClasterPoint | CashBoxPoint): CustomMarkerOptions => {
    let markerOptions: CustomMarkerOptions;

    if ('count' in point) {
        markerOptions = {
            icon: createClusterIcon(point.count),
            count: point.count,
        };
    }

    if ('taxNumber' in point) {
        markerOptions = {
            icon: customIcon,
            taxNumber: point.taxNumber,
        };
    }

    return markerOptions;
};

export const parseClasters = (clasters: Claster[]): ClasterPoint[] => {
    return clasters.map((claster) => {
        const { lat, lon } = Geohash.decode(claster.geoHash);

        return {
            count: claster.count,
            lat,
            lon,
        };
    });
};

export const setZoomLevel = (zoom: number): number | null => {
    if (zoom >= 1 && zoom <= 2) {
        return 1;
    } else if (zoom >= 3 && zoom <= 4) {
        return 2;
    } else if (zoom >= 5 && zoom <= 6) {
        return 3;
    } else if (zoom >= 7 && zoom <= 8) {
        return 4;
    } else if (zoom >= 9 && zoom <= 10) {
        return 5;
    } else if (zoom >= 11 && zoom <= 12) {
        return 6;
    } else if (zoom >= 13 && zoom <= 14) {
        return 7;
    } else if (zoom >= 15 && zoom <= 16) {
        return 8;
    } else if (zoom === 17) {
        return 9;
    } else if (zoom >= 18) {
        return null;
    }

    return null;
};
